import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { t as translate } from "@/lib/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sarthi_lang") || "en");
  useEffect(() => {
    localStorage.setItem("sarthi_lang", lang);
  }, [lang]);
  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key) => translate(key, lang),
  }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
